import React from "react";
import { Dialog, Slide, Backdrop, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import AddUserForm from "layouts/users/component/newUser";
import { useMaterialUIController } from "context";
import { useTheme } from "@mui/material/styles";
const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const AddUserModal = ({ open, onClose, onUserAdded, initialData }) => {
  console.log("initialData", initialData);
  const [controller] = useMaterialUIController();
  const darkMode = controller.darkMode;
  const theme = useTheme();
  return (
    <Dialog
      open={open}
      TransitionComponent={Transition}
      onClose={onClose}
      fullWidth
      maxWidth="sm"
      BackdropComponent={Backdrop}
      BackdropProps={{
        style: {
          backgroundColor: "rgba(0,0,0,0.5)",
          backdropFilter: "blur(4px)",
        },
      }}
      PaperProps={{
        style: {
          marginTop: "15vh",
          borderRadius: "16px",
          overflow: "visible",
        },
      }}
    >
      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 16,
          top: 16,
          color: darkMode ? "white !important" : "text.secondary",
          zIndex: 1,
        }}
      >
        <CloseIcon />
      </IconButton>

      <AddUserForm
        initialData={initialData} // Pass initial data
        onClose={onClose}
        onSuccess={() => {
          onClose();
          onUserAdded();
        }}
      />
    </Dialog>
  );
};

export default AddUserModal;
